import { render } from "./IgrnView.vue?vue&type=template&id=3e0b8a8d&scoped=true"
import script from "./IgrnView.vue?vue&type=script&lang=js"
export * from "./IgrnView.vue?vue&type=script&lang=js"

import "./IgrnView.vue?vue&type=style&index=0&id=3e0b8a8d&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0b8a8d"]])

export default __exports__